import axios from '@plugins/axios';

class UserService {
    getList(params = {}, options = {}) {
        return axios({
            url: `operadora/institution/user`,
            method: 'GET',
            params,
            ...options
        });
    }

    getListWithJuegoSet(params = {}, options = {}) {
        return axios({
            url: `operadora/institution/user/juego-set`,
            method: 'GET',
            params,
            ...options
        });
    }
    create(data = {}, options = {}) {
        return axios({
            url: `operadora/institution/user`,
            method: 'POST',
            data,
            ... options,
        });
    }
    update(id, data, options = {}) {
        return axios({
            url: `operadora/institution/user/${id}`,
            method: 'PUT',
            data,
            ...options,
        });
    }
}

export const BaseUserService = UserService;

export default new UserService();